import React from 'react';
import MyPassengersTotalizersHeaderItem from "./MyPassengersTotalizersHeaderItem";
import { addDecimalPoints, formatCurrency } from "../../../../../../js/shared/utils";

const MyPassengersTotalizersHeader = ({ passengers, totalMiles, totalValue, countReductionsUsed, programId } = props) => {
	return (
		<div className='my-passengers-totalizers-header'>
			<MyPassengersTotalizersHeaderItem
				description='Emissões feitas para'
				value={`${passengers} passageiros`}
			/>
			
			<MyPassengersTotalizersHeaderItem
				description='Qtd. de milhas emitidas'
				value={`${addDecimalPoints(totalMiles)} milhas`}
			/>
			
			<MyPassengersTotalizersHeaderItem
				description='Valor total das milhas'
				value={`${formatCurrency(totalValue)}`}
			/>

			{(programId === 4 && countReductionsUsed > 0) &&
				<MyPassengersTotalizersHeaderItem
				description='Redução de milhas utilizadas'
				value={`${countReductionsUsed < 10 ? '0'+countReductionsUsed : countReductionsUsed} trecho${countReductionsUsed > 1 ? 's' : ''}`}
				/>
			}
		</div>
	);
};

export default MyPassengersTotalizersHeader;